'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PassRecoveryStepOne = undefined;

var _PassRecoveryStepOne2 = require('./PassRecoveryStepOne');

var _PassRecoveryStepOne3 = _interopRequireDefault(_PassRecoveryStepOne2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.PassRecoveryStepOne = _PassRecoveryStepOne3.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/PassRecovery/PassRecoveryStepOne/index.js
// module id = 1722
// module chunks = 0